<form [formGroup]="Form" (submit)="onSubmit()">
  <div class="d-flex flex-column h-100">
    <div #scroll class="scroll-sidebar">
      <div class="container-fluid py-2">
        <!-- Tabs -->
        <!-- Create chat -->
        <div *ngIf="false" class="form-group mt-5">
          <label class="small">Обложка</label>
          <div class="position-relative text-center bg-secondary rounded p-6">
            <div class="avatar bg-primary text-white mb-5">
              <i-feather name="image"></i-feather>
            </div>
            <p class="small text-muted mb-0">
              You can upload jpg, gif or png files. <br />
              Max file size 3mb.
            </p>
            <input id="upload-chat-photo" class="d-none" type="file" />
            <label class="stretched-label mb-0" for="upload-chat-photo"></label>
          </div>
        </div>
        <!--<nz-affix *ngIf="isLoaded" class="w-100" [nzOffsetTop]="0" [nzTarget]="scroll">-->
        <div class="form-group mt-4 w-100">
          <input
            formControlName="title"
            id="new-chat-title"
            class="form-control form-control-lg"
            type="text"
            placeholder="Введите название беседы"
          />
        </div>
        <!--</nz-affix>-->
        <div *ngIf="false" class="form-group mb-0">
          <label class="small" for="new-chat-description">Описание</label>
          <textarea
            formControlName="description"
            id="new-chat-description"
            class="form-control form-control-lg"
            rows="6"
            placeholder="Введите описание беседы"
          ></textarea>
        </div>
        <div *ngFor="let alert of alerts">
          <alert [type]="alert.type" [dismissible]="dismissible" (onClosed)="onClosed(alert)">
            <p>
              <i-feather name="users" class="mr-2"></i-feather>Напишите выше название для беседы, после чего отметьте
              собеседников ниже для содания группового чата.
            </p>
            <p>
              <i-feather name="user" class="mr-2"></i-feather>Для создания одиночного диалога, отметьте одного
              собеседника.
            </p>
          </alert>
        </div>
        <div class="userList">
          <div *ngIf="usersSelectCount > 0" class="mb-4">
          <span
            [ngStyle]="{
              'background-color': appService.stringToHslColor(client.value?.id) + '!important'
            }"
            (click)="toggleUser(client.value)"
            class="badge badge-primary mr-3 mb-2 pointer"
            *ngFor="let client of usersSelect | keyvalue; let i = index"
          >
            <span
              [innerHTML]="client.value?.name?.first + ' ' + client.value?.name?.last | replaceEmojis: 'facebook':14:64"
            ></span>
            <i-feather name="x" class="pointer"></i-feather>
          </span>
          </div>
        </div>

        <app-contacts-list
          [fixedSearch]="false"
          [scroll]="scroll"
          [showServiceToggle]="true"
          (onToggleUser)="toggleUser($event)"
          (onToggleService)="clearUsersSelect()"
          [Service]="Service"
        ></app-contacts-list>
        <!-- Tabs -->
        <!-- Create chat -->
      </div>
    </div>
    <!-- Button -->
    <div class="py-6 sidebar-footer">
      <div class="container-fluid">
        <button
          (click)="showError()"
          (mousemove)="allService.effectMouseMove($event)"
          *ngIf="!existChat?.id; else goChat"
          [disabled]="usersSelectCount == 0"
          class="effectMouse effect-white btn btn-lg btn-primary btn-block"
          type="submit"
        >
          <i-feather name="edit" class="icon-md mr-2"></i-feather>
          <span *ngIf="usersSelectCount != 1">Создать беседу ({{ usersSelectCount }})</span>
          <span *ngIf="usersSelectCount == 1">Создать дилог</span>
        </button>
        <ng-template #goChat>
          <button
            (mousemove)="allService.effectMouseMove($event)"
            (click)="openChat(existChat)"
            class="effectMouse effect-white btn btn-lg btn-primary btn-block"
            type="button"
          >
            <i-feather name="message-square" class="icon-md mr-2"></i-feather>Перейти к беседе
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</form>
